import { Query } from '../../../../hooks/queries'
import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../api/connector'

export type AiSettingsType = {
  intelligent_remediation_guidance_enabled: boolean
  intelligent_remediation_guidance_disclaimer_enabled: boolean
}

interface Response {
  success: boolean
  messages: string[]
  settings: AiSettingsType
}

type AiFetchSettingsArgs = {
  organizationId: string
}

export async function getAiSettings(
  this: ThisConnector,
  { organizationId }: AiFetchSettingsArgs
) {
  return this.connector.get(`${organizationId}/settings/aiml`)
}

export function useFetchAiSettings({ organizationId, enabled }) {
  return useContrastQuery<AiFetchSettingsArgs, Response>(
    [Query.AI_SETTINGS, organizationId],
    getAiSettings,
    {
      organizationId
    },
    {
      cacheTime: 0,
      enabled,
      staleTime: 0
    }
  )
}
